import React ,{Component} from 'react';
import { NavLink,Navigate  } from 'react-router-dom';
import axios from 'axios';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 
import SettingsIcon from '@mui/icons-material/Settings';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox'; 
import FormControlLabel from '@mui/material/FormControlLabel'; 
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import {DragDropContext,Droppable,Draggable} from '@hello-pangea/dnd';
import LocalPrintshopTwoToneIcon from '@mui/icons-material/LocalPrintshopTwoTone';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import ReactToPrint from 'react-to-print';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { blueGrey } from '@mui/material/colors';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import Tooltip from '@mui/material/Tooltip';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import EmailTwoToneIcon  from '@mui/icons-material/EmailTwoTone';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import DeleteIcon from '@mui/icons-material/Delete';
import Columnsettings from './Columnsettings';
import Sendemailvendorbill from './Sendemailvendorbill';
const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}
function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
export default class Adminvendorbill extends Component {
    constructor(props) {
    super(props);
	var strdob = new Date();
var month = "";
if ((strdob.getMonth() + 1) < 10) {
    month = "0" + (strdob.getMonth() + 1);
} else {
    month = (strdob.getMonth() + 1);
}
const currentDate = new Date();
var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();
 this.state = {
checkboxData:'', checkedvalues: '' , 
 vbstatus:'',isselectdisplay:false,open:false,columnsarr:[],
 todate1: currentDate.getFullYear() + '-' + month1 + '-' + lastDay, todate: lastDayOfMonth,
fromdate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
 fromdate1:currentDate.getFullYear() + '-' + month1 + '-' + '01',company:'',
redirect:false,pagename:'',id:'',page:0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
search:'',order:'desc' ,orderBy:'vb_id',
	 vendorbillData:[],ColumnData:[],vendor:'',disablecopyicon:true,vbidies:'',colcount:0
	}
	this.updateColumnssetting=this.updateColumnssetting;       
	}
updateColumnssetting = (text) => {
this.ColumheadervendorbillApi();
	}
 myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 } 
ColumheadervendorbillApi(){
	axios.get(localStorage.getItem("ISIurl")+'ajaxcolumnconfigure.php?action=getall&cc_userid='+localStorage.getItem("ISIuserid")+'&cc_page=7&cc_isdisplay=1')
  .then(resp => {  	
    if(resp.data.length>0){
			this.setState({  
			  ColumnData: resp.data,  
			   colcount:parseInt(resp.data[0].count),
			});
     }
	  else{
		   axios.get(localStorage.getItem("ISIurl")+'ajaxcolumnconfigure.php?action=getall&cc_userid=0&cc_page=7&cc_isdisplay=1')
  .then(resp => {  	
				if(resp.data.length>0){
						this.setState({  
						  ColumnData: resp.data,  
						   colcount:parseInt(resp.data[0].count),
						});
				 }
	     });
	 }
    });
}
componentWillMount() {
	document.title = "Isifol - Vendor Bill";
if(localStorage.getItem("ISIuserid")==null)
		  {
		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
		 this.apicall(this.state.page,this.state.rowsPerPage); 	
		  }
		  else{
		this.PageAccessCheckApi();
		  }
	}
		   this.props.parentdasCallback(
            "Vendor Bills~"
        );
}
PageAccessCheckApi() {
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=8')
  .then(resp => {
	  let strreturn=resp.data;
      if (strreturn!==0) {
       this.apicall(this.state.page,this.state.rowsPerPage); 
      } else {
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
  });
}
apicall(page,rowsPerPage){
axios.get(localStorage.getItem("ISIurl")+'ajaxvendorbill.php?action=getall&ve_businessname='+this.state.vendor+'&vb_status='+this.state.vbstatus+'&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&vb_type=1&vb_cmp_id='+localStorage.getItem("ISIcmpid")+'&StartIndex='+page+'&PageSize='+rowsPerPage)
  .then(resp => {  	
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
		var itemsArray=resp.data;	
			this.setState({  
			  vendorbillData: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   rowsPaging:[],rowsPaging:copy	
			});
     }
	  else{
		   this.setState({vendorbillData:[],totaldata:0});
	 }
 this.ColumheadervendorbillApi();
    });
}
handleClickSearch=()=>{
 this.apicall(this.state.page,this.state.rowsPerPage); 
}
handleChangePage = (event, newPage) => {  
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
  }; 
   handleChangeRowsPerPage = event => {  
    let pageval = event.target.value;
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
  };
    handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
  });
};
fromdatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }
    this.setState({
        fromdate: dayjs(dateObj),
        fromdate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
}
  toatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }
  }
	handleOpen = () => {
    this.setState({ open: true });
  };
	handleClickOpen = (e) => { 
  this.setState({open:!this.state.open,
	  });
};
  CloseMoreoption = (date) =>{
	this.setState({isselectdisplay:false});
}
  Handleclickviewmore= (e) =>{
	  this.setState({isselectdisplay:true});
  }
       addprintbox(){
    setTimeout(() => this.refs.PrintBox.handleClickOpen(),500);
 }
  /*chcekboxbulkdelete*/
    HandleAllcheckbox=()=>{
	 var studArray = this.state.vendorbillData;
	 const updatedArray = [...this.state.vendorbillData];
	 this.setState({allchecked:!this.state.allchecked},() => {
	     if(this.state.allchecked===false)
		 {
		 var subnewRow=studArray.map((rowssub,j) => {
					 updatedArray[j].isseleceted = "0" ;
				 });
		  }
		 else if(this.state.allchecked===true)
			 {
				  var subnewRow = studArray.map((rowssub, j) => {
				   updatedArray[j].isseleceted = "1" ;
			   });
			 }
			this.setState({vendorbillData:updatedArray,},()=>{
			const selectedItems= this.state.vendorbillData.filter(item => item.isseleceted==="1")
		  const selectedIds = selectedItems.map(item => item.vb_id);
		  const selectedIdsString = selectedIds.join(',');
		  this.setState({vbidies:selectedIdsString},()=>{
		  },()=>{
		  });   if (selectedIds.length >= 2) {
         this.setState({disablecopyicon: false,});
         } 
		 else{
			 this.setState({disablecopyicon:true });
		 }
			});
	 }); 
  }
  HandleCheckbox=(id,rowsd)=>{
  const updatedArray=[...this.state.vendorbillData];
	  if(updatedArray[rowsd].isseleceted==="0")
	  {
		  updatedArray[rowsd].isseleceted = "1" ;
	  }
	  else
	  {
	  updatedArray[rowsd].isseleceted = "0" ;
      }
	  this.setState({vendorbillData: updatedArray,},()=>{
		 const selectedItems= this.state.vendorbillData.filter(item => item.isseleceted==="1")
		  const selectedIds = selectedItems.map(item => item.vb_id);
		  const selectedIdsString = selectedIds.join(',');
		  this.setState({vbidies:selectedIdsString},()=>{
		  });
		 if (selectedItems.length >= 2) {
         this.setState({disablecopyicon: false });
         } 
		 else{
			 this.setState({disablecopyicon: true });
		 }
	  }) ;
  }
    onClickBulkdelete(){
	const idsArray = this.state.vbidies.split(",").filter(id=>id.trim() !==""); 
    const count = idsArray.length; 
    if (count === 0) {
   this.setState({errormessage:"You Have Not Checked any checkbox Please select any one",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
  }
	  let r = window.confirm("Do you really want to Delete?");
		 if(r == true){
			  var formData = new FormData(); 
					 formData.append('action','delete')	
					 formData.append('vb_id',this.state.vbidies)
			         formData.append('userid',localStorage.getItem("ISIuserid"))
					  axios.post(localStorage.getItem("ISIurl")+"ajaxvendorbill.php", formData, {
						}).then(res =>{
							  this.apicall(this.state.page,this.state.rowsPerPage); 
						});
		 }
  }
    OnSelectSendEmail(){
	    var formData = new FormData(); 
					 formData.append('action','sendemail')	
					  formData.append('vb_id',this.state.vbidies)
					  formData.append('vb_cmp_id',localStorage.getItem("ISIcmpid"))
					    axios.post(localStorage.getItem("ISIurl")+"ajaxvendorbill.php", formData, {
						}).then(res =>{
							  this.apicall(this.state.page,this.state.rowsPerPage); 
						});
  }
  /**/
   addcheckbox(){
     setTimeout(() => this.refs.Columnsettings.handleClickOpen(),500);
 }
	render()
	{
		  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
		const { checkedvalues } = this.state;
		return(
		   <React.Fragment>
<div className="searchbox">
<ul>
 <li>
        <p>Search</p>
        <p>
          <TextField
            variant="outlined"
            fullWidth
			className="txtbox"
            value={this.state.vendor}
            id="vendor"
            inputProps={{ tabIndex: "1", maxLength: 150 }}
            name="vendor"
            onChange={this.myChangeHandler}
            InputProps={{
              endAdornment: (
                <SearchOutlinedIcon style={{ marginLeft: 8 }} />
              ),
            }}
          />
        </p>
      </li>
<li>
<p><p>From Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.fromdate) }
className="txtbox"
    onChange={this.fromdatehandler} format="MM/DD/YYYY"
/>  </DemoContainer>
</LocalizationProvider></p>
</li>
<li>
<p><p>To Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.todate) }
className="txtbox"
onChange={this.toatehandler} format="MM/DD/YYYY"
/>  </DemoContainer>
    </LocalizationProvider> </p></li>
<li>
<p>&nbsp;</p>
<p>
<Button
type="submit"
variant="outlined" 
className="morebtn"
onClick={this.Handleclickviewmore}
          >
            More
          </Button>
  <span className="closeincon">
   {this.state.isselectdisplay === true && (
      <CloseRoundedIcon onClick={this.CloseMoreoption} />
    )}
   </span>
</p>
</li>
<li>
<p>&nbsp;</p>
	 <p className="searchbutton">
       <Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
  onClick={this.handleClickSearch}
>
  Search 
</Button>
        &nbsp;
        <ReactHTMLTableToExcel
          variant="contained"
          color="primary"
          id="test-table-xls-button"
          className="exportbtn"
          table="VendorBill"
          filename="Vendor Bill report"
          sheet="Vendor Bill Report"
          buttonText="EXPORT"
        />
      </p>
		</li>
</ul>
<PrintBox ref="PrintBox" childcols={this.state.ColumnData} vbidies={this.state.vbidies}/>
<Columnsettings 
ref="Columnsettings"  
pageval={7}
updateDonenew={this.updateColumnssetting}/>
<ul>
	{this.state.isselectdisplay===true &&(
	<li>
<p>Status</p> <p><Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.myChangeHandler}
  id="role"
  value={this.state.vbstatus}
  name="vbstatus"
  inputProps={{tabIndex: "4"}}
        >
		<option value={0}>All</option>
<option value={1}>Draft</option>
<option value={2}>Unpaid</option>
<option value={3}>Part Paid</option>
<option value={4}>Paid</option>
<option value={5}>Void</option>
<option value={6}>Overdue</option>
<option value={7}>Outstanding</option>
<option value={8}>Disputed</option>
  </Select></p>
</li>
	)}
</ul>
</div>	
<div className="addandbacbtn"> <NavLink  to="/Addvendorbill" className="frmSecondarybtn">New Bill</NavLink></div>
  	<div className="clear"></div>	
	{this.state.vbidies!=='' && (
	<div className="iconlistprint">
<p>
<Tooltip title="Print" placement="top">
  <IconButton>
  <LocalPrintshopIcon onClick={()=>{this.refs.PrintBox.handleClickPrint();}}/>
  </IconButton>
</Tooltip>
<Tooltip title="Email" placement="top">
  <IconButton onClick={() => this.refs.Sendemailvendorbill.handleaddfileClose()}>
    <EmailTwoToneIcon />
  </IconButton>
</Tooltip>
{this.state.disablecopyicon === true && (
  <a href={'/#/Addvendorbill?vbnid='+this.state.vbidies+'&copy=1'} >
    <Tooltip title="Copy" placement="top">
      <IconButton>
        <ContentCopyTwoToneIcon />
      </IconButton>
    </Tooltip>
  </a>
)}
<Tooltip title="Delete" placement="top">
  <IconButton>
 <DeleteIcon onClick={()=>{this.onClickBulkdelete()}} />
  </IconButton>
</Tooltip>
 </p>
</div>	
	)}
<div className="estimatebox">
<div onClick={this.handleOpen} className="ui-conatiner">
       <span className="congiguration" onClick={()=>{this.addcheckbox()}}>   <SettingsIcon /> </span>
        </div>
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table stickyHeader aria-label="sticky table"> 
 <TableHead>
		   <TableRow>
 <TableCell>   
			<Checkbox 
           checked={this.state.allchecked}
           onChange={()=>{this.HandleAllcheckbox()}}
            inputProps={{ 'aria-label': 'controlled' }}
            sx={{
          color: 'white', 
         '&.Mui-checked': {
            color: 'white', 
        },}}
              /> 	
			</TableCell>
{this.state.ColumnData.map((col,i) => {  
           return ( 
		    <TableCell>
			{col.cc_displayname}
			 </TableCell>
		 )
})}
 </TableRow>
     </TableHead>
  <TableBody>
{this.state.vendorbillData.map((item,index) => {  
           return ( <React.Fragment>
 <TableRow key={index} >
	  <TableCell>{item.isseleceted==="0" && (
        <Checkbox
         onChange={()=>{this.HandleCheckbox(item.vcn_id,index)}}
         inputProps={{ 'aria-label': 'controlled' }}
		      sx={{'&.Mui-checked': {
            color: 'gray', 
                },
                }}
        /> 
      )}{item.isseleceted==="1" && (
        <Checkbox
      checked
      onChange={()=>{this.HandleCheckbox(item.vcn_id,index)}}
	       sx={{ '&.Mui-checked': {
            color: 'gray', 
            },
          }}
     /> 
     )}</TableCell>
{this.state.ColumnData.map((cols,i) => { 
	  let colsname	=  cols.cc_columnname; 
	  return ( <React.Fragment>
 {colsname!=="vb_file" &&(<React.Fragment>
 <TableCell>
  {(colsname!=="total" ) &&(
 <a className="link" href={"#/vendorbillviewmore?vbid="+item.vb_id+""}>{item[""+colsname+""]}</a>
  )}
  {(colsname==="total" ) &&(
 <a className="link" href={"#/vendorbillviewmore?vbid="+item.vb_id+""}>
 {
	(parseFloat(item.vbp_total)).toFixed(2)}</a>
	 )}
  </TableCell>
 </React.Fragment>)}
  {(colsname==="vb_file" ) &&(
	 <TableCell>
	 {( item.vb_file!=="") &&(
 <a className="link" href={localStorage.getItem("ISIurl")+"uploads/"+item.vb_file+""} target="_blank">View</a>
  )}
 </TableCell>
	 )}
			</React.Fragment>	);
					})}
 </TableRow>
				</React.Fragment>	
				);
					})}
					{this.state.totaldata===0 &&(
					<TableRow key={0} >
<TableCell align="center" colspan={this.state.colcount}>No Records</TableCell>
					</TableRow>
					) }
 </TableBody>
</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[10,20,50, 100, 150,200]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />    
  </Paper>
 </div>
<div style={{"display":"none"}}>
<Paper className={useStyles.root}>
  <TableContainer className={useStyles.container}>  
  <Table stickyHeader aria-label="sticky table" id="Estimate">  
<TableHead> 
<TableRow>
            {this.state.ColumnData.map((cols,i) => {  
           return (
		    <TableCell>{cols.cc_displayname}</TableCell>
		   )
		  })}
                      </TableRow></TableHead>
                      <TableBody>
                     {this.state.vendorbillData.map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >
{this.state.ColumnData.map((cols,i) => { 
	  let colsname	=  cols.cc_columnname; 
	  return ( <React.Fragment>
 {colsname!=="vb_file" &&(<React.Fragment>
 <TableCell>
  {(colsname!=="total" ) &&(
 <span>{item[""+colsname+""]}</span>
  )}
  {(colsname==="total" ) &&(
 <a className="link" href={"#/vendorbillviewmore?vbid=="+item.vb_id+""}>
 {
	(parseFloat(item.iop_total)).toFixed(2)}</a>
	 )}
  </TableCell>
 </React.Fragment>)}
  {(colsname==="vb_file" ) &&(
	 <TableCell>
	 {( item.vb_file!=="") &&(
 <a className="link" href={localStorage.getItem("ISIurl")+"uploads/"+item.vb_file+""} target="_blank">View</a>
  )}
 </TableCell>
	 )}
			</React.Fragment>	);
					})}
 </TableRow>
 </React.Fragment>	
);
					})}
{this.state.totaldata===0 &&(
					<TableRow key={0} >
<TableCell align="center" colspan={this.state.colcount}>No Records</TableCell>
</TableRow>
					) }
 </TableBody>
</Table>
  </TableContainer> 
  </Paper>
</div>
<Sendemailvendorbill ref="Sendemailvendorbill" 
 id={this.state.vbidies} 
 headingname="Vendor Bill"
 adminname="Estimates"
 aoid="13"
 />
	   </React.Fragment>	
		)
	}
}
export class PrintBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      printopen: false,
	  VendorArray:[],
    };
  }
 handleClickPrint = () => {
  this.GetVendorCreditBYIdes(this.props.vbidies)
};
  handleClose = () => {
    this.setState({ printopen: false });
  };
 GetVendorCreditBYIdes(id){
axios.get(localStorage.getItem("ISIurl")+'ajaxvendorbill.php?action=getall&vb_id='+id)
  .then(resp => {  	
    if(resp.data.length>0){
			this.setState({  
			  VendorArray: resp.data,  
			},()=>{
				 setTimeout(() =>
document.getElementById('print-button').click() 
,500);
			});
     }
	  else{
		   this.setState({VendorArray:[]});
	 }
    });
}
  render() {
 return (
	 <React.Fragment>
	 <div className="printmod">
	<div ref={el => (this.componentRef = el)} >
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table stickyHeader aria-label="sticky table"> 
 <TableHead>
          <TableRow>
		  {this.props.childcols.map((cols,i) => {  
           return (
		    <TableCell>{cols.cc_displayname}</TableCell>
		   )
		  })}
          </TableRow>
        </TableHead>
  <TableBody>
{this.state.VendorArray.map((item,index) => {  
           return ( <React.Fragment>
 <TableRow key={index} >
{this.props.childcols.map((cols,i) => { 
	  let colsname	=  cols.cc_columnname; 
	  return ( <React.Fragment>
 {colsname!=="vb_file" &&(<React.Fragment>
 <TableCell>
  {(colsname!=="total" ) &&(
 <span>{item[""+colsname+""]}</span>
  )}
  {(colsname==="total" ) &&(
 <span>
 {
	(parseFloat(item.vbp_total)).toFixed(2)}</span>
	 )}
  </TableCell>
 </React.Fragment>)}
  {(colsname==="vb_file" ) &&(
	 <TableCell>
	 {( item.vb_file!=="") &&(
 <a className="link" href={localStorage.getItem("ISIurl")+"uploads/"+item.vb_file+""} target="_blank">View</a>
  )}
 </TableCell>
	 )}
			</React.Fragment>	);
					})}
 </TableRow>
				</React.Fragment>	
				);
					})}
 </TableBody>
</Table>
  </TableContainer> 
  </Paper>
</div>
<ReactToPrint 
            trigger={() => <p id="print-button" className="Primarybuttons">Print </p>}
			content={() =>  this.componentRef} />
		</div>	
			 </React.Fragment>
 ) }
}